
import { brands } from 'Constants';
const ciTitle = {};

ciTitle[brands.EBCBS]="Specified disease benefits"
ciTitle[brands.EBC]="Specified disease benefits"

ciTitle[brands.BCNY]="Specified disease benefits"
ciTitle[brands.BCBSNY]="Specified disease benefits"

ciTitle[brands.ABCBS]="Critical Illness benefits"
ciTitle[brands.ABC]="Critical Illness benefits"

ciTitle[brands.ABCBH]="Critical Illness benefits"
ciTitle[brands.Anthem_HK]="Critical Illness benefits"


 

export default state => (state.ciTitle = ciTitle[state.brandID]);
